import React, {useContext, useMemo, useState} from "react";
import PropTypes from "prop-types";
import {AutoSizer, List} from "react-virtualized";

import UIPopupContext from "../UIPopupContext";
import UiSwitch from "../../UiSwitch";
import TextInput from "../../../Generic/textInput";
import {getDisplayFabricatorName} from "./referralPopupApi";


const ReferralPopupContentListProviderItem = (props) => {

  const {style, fabricator} = props;

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);

  let referrals = uiPopupContext.referrals || [];

  const alreadyExistingRelation = referrals.find(referral => referral.childFabricatorId === fabricator.id);

  const [percentage, setPercentage] = useState(alreadyExistingRelation ? alreadyExistingRelation.percentage || "" : "");
  const [qcPercentage, setQcPercentage] = useState(alreadyExistingRelation ? alreadyExistingRelation.qcPercentage || "" : "");

  const getNewReferralItem = (enabled, percentage, qcPercentage) => {
    return {
      parentFabricatorId: uiPopupContext.activeFabricatorId,
      childFabricatorId: fabricator.id,
      enabled,
      percentage,
      qcPercentage,
    }
  }

  const onFabricatorToggleClick = () => {
    if (alreadyExistingRelation) {
      alreadyExistingRelation.enabled = !alreadyExistingRelation.enabled;
    } else {
      referrals.push(getNewReferralItem(true, +percentage || 0, +qcPercentage || 0));
    }
    uiPopupDispatch({referrals});
  }
  const onPercentageInputChange = (value) => {
    setPercentage(value);
    if (alreadyExistingRelation) {
      alreadyExistingRelation.percentage = +value;
    } else {
      referrals.push(getNewReferralItem(false, +value || 0, +qcPercentage || 0));
    }
    uiPopupDispatch({referrals});
  }

  const onQCPercentageInputChange = (value) => {
    setQcPercentage(value);
    if (alreadyExistingRelation) {
      alreadyExistingRelation.qcPercentage = +value;
    } else {
      referrals.push(getNewReferralItem(false, +percentage || 0, +value || 0));
    }
    uiPopupDispatch({referrals});
  }

  return (
    <div style={style} className={"ui-list-li border-box flex flex--center flex--between"}>
      <div className="pr-1 flex flex--center flex--start">
        <UiSwitch onClick={onFabricatorToggleClick}
                  className="ui-switch--light"
                  textId={""}
                  checked={alreadyExistingRelation ? alreadyExistingRelation.enabled : false}/>
        <span className="pl-05 pr-two-lines break-word">
          {getDisplayFabricatorName(fabricator)}
        </span>
      </div>
      <div className="flex flex--center">
        <TextInput className={"generic-popup-textbox w-4 m-0 radius-5 h-175 text-center"}
                   placeholder={"%"}
                   numberInput={true}
                   onChange={onPercentageInputChange}
                   value={percentage ? percentage + "%" || "" : ""}/>
        <TextInput className={"ml-05 generic-popup-textbox w-4 m-0 radius-5 h-175 text-center"}
                   placeholder={"%"}
                   numberInput={true}
                   onChange={onQCPercentageInputChange}
                   value={qcPercentage ? qcPercentage + "%" || "" : ""}/>
      </div>
    </div>
  )
};

ReferralPopupContentListProviderItem.propTypes = {
  style: PropTypes.object.isRequired,
  fabricator: PropTypes.object.isRequired,
}

export default ReferralPopupContentListProviderItem
